import { eNavigationTreeNodeId } from "../../../@client/Theasoft_Data"
import app_serverResources from "../../../@resource-interfaces/app_serverResources"

type NavItemKey = `NavItem_${eNavigationTreeNodeId}`

const map = (nodeId: eNavigationTreeNodeId): NavItemKey => `NavItem_${nodeId}`

// Für jeden eNavigationTreeNodeId enum Wert muss ein entsprechender Resourcen Eintrage `NavItem_${enumName}` in Resources.resx existieren
// Sonst gibt es hier einen Typescript Fehler. Am Ende des Typescript Fehlers
// sollte der fehlende Key genannt werden, z.B.
// Type '"NavItem_WorkingTimes"' is not assignable to type 'keyof app_serverResources'.
export const mapNodeIdToTranslation = (
  nodeId: eNavigationTreeNodeId
): keyof app_serverResources => map(nodeId)
